import * as user from './user.js'
import * as buried from './buried.js'
import * as search from './search.js'
import * as file from './file.js'
import * as coin from './coin.js'
import * as task from './task.js'
import * as box from './box.js'
import * as spin from './spin.js'
import * as wheel from './wheel.js'
import * as transfer from './transfer.js'
import * as sms from './sms.js'
import * as common from './common.js'
import * as asset from './asset.js'
import * as agent from './agent.js'
import * as battle from './battle.js'
import * as referralEarn from './referralEarn.js'
import * as waRecall from './waRecall.js'
import * as agentGrowth from './agentGrowth.js'

export default {
  ...asset,
  ...user,
  ...buried,
  ...search,
  ...file,
  ...coin,
  ...task,
  ...box,
  ...spin,
  ...wheel,
  ...transfer,
  ...sms,
  ...common,
  ...agent,
  ...battle,
  ...referralEarn,
  ...waRecall,
  ...agentGrowth
}
